import React from "react"
interface IProps {
  color?: string
  width?: number
  height?: number
}
const Today: React.SFC<IProps> = (props: IProps) => {
  const width = props.width || 36.429
  const height = props.height || 40.633
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36.429"
      height="40.633"
      viewBox="0 0 36.429 40.633"
      style={{ width, height }}
    >
      <g id="Group_1" data-name="Group 1" transform="translate(8459 -6678)">
        <path id="calendar" d="M36.627,42.633H5.8A2.8,2.8,0,0,1,3,39.83V9.006A2.8,2.8,0,0,1,5.8,6.2H8.6V7.6a4.2,4.2,0,0,0,8.407,0V6.2h8.407V7.6a4.2,4.2,0,0,0,8.407,0V6.2h2.8a2.8,2.8,0,0,1,2.8,2.8V39.83A2.8,2.8,0,0,1,36.627,42.633Zm0-26.621H5.8V39.83H36.627Zm-7.049-5.6a2.759,2.759,0,0,1-2.759-2.759V4.759a2.759,2.759,0,0,1,5.518,0V7.648A2.759,2.759,0,0,1,29.578,10.407Zm-16.813,0a2.759,2.759,0,0,1-2.759-2.759V4.759a2.759,2.759,0,1,1,5.518,0V7.648A2.76,2.76,0,0,1,12.764,10.407Z" transform="translate(-8462 6676)" fill="#a0a0a0" />
        <path id="arrow-up-left" d="M0,11.164,3.883,7.281l8.252,8.252,3.4-3.4L7.281,3.883,11.164,0H0Z" transform="translate(-8440.785 6694.177) rotate(45)" fill={props.color || "#a0a0a0"} />
      </g>
    </svg>
  )
}

export default Today
